import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import TopNav from "../containers/navs/Topnav";
import Sidebar from "../containers/navs/Sidebar";

const AppLayout = props => {
  const { containerClassnames, children, history } = props;
  return (
    <div id="app-container" className={containerClassnames}>
      <TopNav history={history} {...props} />
      <Sidebar />
      <main>
        <div className="container-fluid">{children}</div>
      </main>
    </div>
  );
};

AppLayout.defaultProps = {
  containerClassnames: "",
  history: {},
  children: {}
};

AppLayout.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  containerClassnames: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object,
  children: PropTypes.node
};

const mapStateToProps = ({ menu }) => {
  const { containerClassnames } = menu;
  return { containerClassnames };
};
const mapActionToProps = {};

export default withRouter(
  connect(
    mapStateToProps,
    mapActionToProps
  )(AppLayout)
);
